module.exports = "/images/plus-sign.svg?e12fb6589835a9d86a58a46deae9a7a8";